import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private data = new BehaviorSubject<{
    sub?: string; 
    master?: boolean; 
    permissoes?: any[], 
    iat?: number, 
    email?:string, 
    pessoaID?: string, 
    circulo?: string, 
    nome?: string,
    fotoUrl?: string,}
  >({});

  private dataEquipe = new BehaviorSubject<any>(null);

  updateData(newData: any) {
    this.data.next(newData);
  }

  currentData() {
    return this.data.value;
  }

  updateDataEquipe(newData: any) {
    this.dataEquipe.next(newData);
  }

  currentDataEquipe() {
    return this.dataEquipe.value;
  }

  currentDataMaster(): boolean | undefined {
    return this.data.value.master;
  }
  
}